import { Page, Modal, Link } from '@shopify/polaris';
import './approvalModal.scss';
import { updatePlan, getPlanDetails } from '../../redux/actions/pricing';
import { PLAN_NEW_FREE, PLAN_OLD_FREE } from '../../constants/constants';
import { sendCleverTapEvent_planUpdate } from '../../common/helperFunctions';

const ApprovalModal = (props: any) => {
  const fetchPlanDetails = async (planId: string) => {
    await getPlanDetails(planId).then((res: any) => {
      if (res) {
        localStorage.setItem('features', res.plan.featuresList);
      }
    });
  };

  const activatePlan = (planId: number) => {
    let shop = JSON.parse(localStorage.getItem('shop') || '{}');
    let params = {
      from: 'pricing',
      returnUrl: window.location.origin + '/confirmation'
    }
    updatePlan(shop.userId, planId.toString(), params).then(
      async (res: any) => {
        if (res.status === 'success' || res === 202) {
          await fetchPlanDetails(planId.toString());
          sendCleverTapEvent_planUpdate(planId, shop);
          if (res.charge && res.charge.confirmationUrl) {
            window.open(res.charge.confirmationUrl, '_self');
          } else {
            props.setShowModal(false);
          }
        }
      },
      (err) => {
        //setIsLoading(false);
      }
    );
  };
  const subscribeToFreePlan = () => {
    activatePlan(PLAN_NEW_FREE);
  };
  return (
    <Page title=''>
      <Modal
        open={props.showModal}
        sectioned={true}
        title={''}
        onClose={() => {
          props.setShowModal(false);
        }}
      >
        <Modal.Section>
          <div className='basic-approval-modal'>
            <div className='approvalModalHeading'>
              Shopify Approval Required
            </div>
            <div className='approvalModalContent'>
              To enable {props.feature}, Shopify approval is required. Please
              note that after enabling {props.feature}, you will be charged
              monthly based on the consumption of Whatsapp Messages.
            </div>
            <button
              className='approvalModalButtonCss'
              type='button'
              onClick={() => subscribeToFreePlan()}
            >
              Proceed to Approval
            </button>
          </div>
          <div className='approvalModalFooter'>
            To learn more about pricing{' '}
            <Link
              external={true}
              url='https://docs.google.com/spreadsheets/u/2/d/1GX6yTDK8imK0YuOFCkU-Lpa3nCFifuq_oaujFvQaiCE/edit?usp=sharing'
            >
              {' Click here'}
            </Link>
          </div>
        </Modal.Section>
      </Modal>
    </Page>
  );
};

export default ApprovalModal;
